export class generatePDF{
  static table(headers, body){
    const max = Math.max(...headers.map(e => {return e.length}));
    const anchos = Array(max).fill('auto');
    var table = {
      headerRows: headers.length,
      widths: anchos,
      body: []
    }

    var aux = [];
    for(const h of headers){
      for(const e of h){
        aux.push({
          text: e.text,
          fillColor: '#eeeeee',
          color: '#808080',
          bold: true,
          fontSize: e.fontSize?e.fontSize:11,
          alignment: 'center',
          colSpan: e.col
        });
        aux.push(...Array(e.col-1).fill({}));
      }
      table.body.push(aux);
      aux = [];
    }

    const fontSize = 10;
    var aux2 = [];
    for(const d of body){
      for (const e of d){
        aux2.push({
          text: `${e.text}`,
          color: e.color !==''&&e.color !==undefined?e.color:'#808080',
          border: e.border!==undefined?e.border:[false, true, false, true],
          borderColor: e.border!==undefined?e.border_color:['#d6d6d6', '#d6d6d6', '#d6d6d6', '#d6d6d6'],
          borderWidth: e.border!==undefined?e.border_width:undefined,
          fontSize: e.fontSize?e.fontSize:10,
          fillColor: e.fontGround,
        });
      }
      table.body.push(aux2);
      aux2 = [];
    }

    return {
      alignment: 'center',
      table: {
        widths: ['*','auto','*'],
        body: [
          [
            '',
            {
              table: table,
              alignment: 'center',
              layout: {
                hLineColor: () => '#E0E0E0',
                vLineColor: () => 'white',
              }
            },
            '',
          ]
        ]
      },
      layout: 'noBorders'
    }
  }
  static titles(title, subTitle){
    return {
      text: [
        {text: title, fontSize: 19, bold: true},
        {text: ' • ', fontSize: 19},
        {text: subTitle, fontSize: 18, color: '#A7A9AC'}
      ],
      margin: [ 0, 10, 0, 10 ]
    }
  }
}